import { MyCompanies } from './my-companies';

export default MyCompanies;
